import { createSelector } from 'reselect'

export const getMonth = state => state.reportCustomerTurnovers.get('month')
export const getData = state => state.reportCustomerTurnovers.get('data')
export const getFetching = state => state.reportCustomerTurnovers.get('fetching')

export const createGetDataSelector = () => createSelector([getData], data => data)
